module.exports = __webpack_public_path__ + "img/plexus-3-small.cbbc076e.png";